import { useState } from 'react';

interface UseEditDialogProps {
  setOpened: (value: boolean) => void;
}
export interface DialogError {
  titleTextId?: string;
  descriptionTextId?: string;
  error?: Error;
}

export const useSubmitDialog = ({ setOpened }: UseEditDialogProps) => {
  const [openedLeaveAlert, setOpenedLeaveAlert] = useState<boolean>(false);
  const [openedConfirmAlert, setOpenedConfirmAlert] = useState<boolean>(false);
  const [dialogError, setDialogError] = useState<DialogError | undefined>(undefined);

  const handleSubmit = async (onSubmit: () => Promise<void>) => {
    try {
      await onSubmit();
      handleClose();
    } catch (error) {
      throw new Error(`Unable to submit: ${error}`);
    }
  };

  const handleClose = () => {
    setOpened(false);
    setOpenedConfirmAlert(false);
    setOpenedLeaveAlert(false);
  };

  return {
    openedLeaveAlert,
    openedConfirmAlert,
    setOpenedLeaveAlert,
    setOpenedConfirmAlert,
    handleSubmit,
    handleClose,
    dialogError,
    setDialogError,
  };
};
